import * as actionConsts from './actions';
import update from 'react/lib/update';
import * as dailyReportActionConsts from '../actions';

export const initState = {
  activities: []
}


export default (state=initState, action) => {
  switch (action.type) {
    case dailyReportActionConsts.DAILY_REPORT_GET_SUCCESS:
      return update(state, {
        activities: {
          $set: action.activities
        }
    });
    case actionConsts.DAILY_REPORT_UPDATE_ACTIVITY_NAME:
      return update(state, {
        activities: {
          [action.activityIndex]: {
            name: {
              $set: action.activityName
            }
          }
        }
    });
    case actionConsts.DAILY_REPORT_UPDATE_ACTIVITY_HOURS:
      return update(state, {
        activities: {
          [action.activityIndex]: {
            hours: {
              $set: action.activityHours
            }
          }
        }
    });
    case actionConsts.DAILY_REPORT_UPDATE_ACTIVITY_TOUCHED:
      return update(state, {
        activities: {
          [action.activityIndex]: {
            [action.inputType]: {
              $set: true
            }
          }
        }
    });
    case actionConsts.DAILY_REPORT_UPDATE_PREDEFINED_ACTIVITY:
      return update(state, {
        activities: {
          [action.activityIndex]: {
            activity: {
              $set: action.activity
            }
          }
        }
    }); 
    case actionConsts.DAILY_REPORT_ADD_ACTIVITY:
      return update(state, {
        activities: {
          $push: [action.activity]
        }
    });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Activities/reducer.js